import React from 'react'

const Pageloader = (props) => {
    return (
        <div className="pageloader is-active"><span className="title">Pageloader</span></div>
    )
}

export default Pageloader
